const modifiers = {	
Blaster: 76.9134,
controller: 51.2809,
defender: 56.4132,
Scra: 31.9052,
Tank: 35.2552,
Khel: 53.3852,
Sent: 45.5837,
Bru: 37.6097,
corruptor: 56.4132,
dom: 73.9593,
MM: 46.1537,
Sta: 33.8449,
SoA: 56.4132,
}

export default modifiers;